import React, {FC, Fragment} from 'react';
import {connect} from "react-redux";
import WrapperPreloader from "../../components/WrapperPreloader";
import PreferencesNoResults from '../../components/Mixer/PreferencesNoResults';
import Header from "../../components/Header";
import MixesList from "../../components/MixesList";
import {cleanActivePreferences, setCurrentMix} from "../../modules/SelectionPreferences";
import BaseButton from "../../components/form/Button";
import {useHistory} from 'react-router-dom';
import {IMix} from "../../constants/types";

interface IMixerPreferencesContainer {
    mixes: Array<IMix>,
    isLoading: boolean,
    setCurrentMix: any,
    cleanActivePreferences: any
}

const MixerPreferencesContainer: FC<IMixerPreferencesContainer> = ({
                                                                       mixes,
                                                                       isLoading,
                                                                       setCurrentMix,
                                                                       cleanActivePreferences
                                                                   }) => {
    const history = useHistory();
    const clickHandler = () => {
        history.push("/mixer");
        cleanActivePreferences()
    };

    return (
        <WrapperPreloader
            isLoading={isLoading}
        >
            <Fragment>
                <Header isContentCenter>
                    Результаты
                </Header>
                {
                    mixes
                        ? (
                            <Fragment>
                                <MixesList
                                    mixes={mixes}
                                    pathUrl="/mixer/pref-mix/"
                                    setTobaccoIndex={setCurrentMix}
                                />
                                <div className="mixer-now__button-wrap">
                                    <div className="mixer-now__find-button">
                                        <BaseButton
                                            isFullWidth
                                            isGreenButton
                                            sizeBorderRadius={10}
                                            sizePadding="12px 0"
                                            onClick={clickHandler}
                                        >
                                           <span className="mixer-now__button-text">
                                         Сбросить
                                           </span>
                                        </BaseButton>
                                    </div>
                                </div>
                            </Fragment>
                        )
                        : <PreferencesNoResults/>
                }
            </Fragment>
        </WrapperPreloader>
    )
};

const mapStateToProps = (state: any) => ({
    mixes: state.selectionPreferences.mixesPreferences,
    isLoading: state.selectionPreferences.isLoading
});

const mapDispatchToProps = (dispatch: any) => ({
    setCurrentMix: (id: number) => dispatch((setCurrentMix(id))),
    cleanActivePreferences: () => dispatch(cleanActivePreferences()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MixerPreferencesContainer)

